import { render, staticRenderFns } from "./BirthdayItem.vue?vue&type=template&id=2fa3e1a8"
import script from "./BirthdayItem.ts?vue&type=script&lang=ts&external"
export * from "./BirthdayItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports